export const REPORTS_ROUTES = {
	reports: "/app/reports",
} as const;
